/**
 * @desc 获取物流订单明细
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<defs.tms.TransportMasterResponseDto>;
export function request(tmsNo: string | number, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/transportMaster/getTraMasterDetail/${tmsNo}`, {
      method: "POST",

      ...options,
    }),
  );
}
